import LazyLoad from './lazyLoad';
import Drops from './drops';
import HardwareAjax from './hardwareAjax';

const $ = jQuery.noConflict();

'use strict';
const LoadMoreHardware = {
	$domLoadBtn: $('.js-load-more'),
	$wrapper: $('.js-hardware-wrap-lode-more'),
	$wrapper2: $('.js-hardware-wrap-more-lode-more-2'),
	page: 1,
	page2: 1,


	init: function() {
		this.bindEvents();
	},

	bindEvents: function() {

		$('.js-load-more').on('click', function() {
			Drops.init();
			if (HardwareAjax.catId && HardwareAjax.taxonomy && HardwareAjax.catName) {

				$.ajax({
					type: 'POST',
					// eslint-disable-next-line no-undef
					url: mongotelAjax.ajaxUrl,
					data: {
						action: 'LoadMoreHardware',
						page: LoadMoreHardware.page + 1,
						catId: HardwareAjax.catId,
						taxonomy: HardwareAjax.taxonomy,
						catName: HardwareAjax.catName
					},
					success: function(response) {
						$(response.htmlPosts).appendTo($('.js-hardware-wrap-lode-more'));
						$(response.htmlPosts2).appendTo($('.js-hardware-wrap-more-lode-more-2'));

						LoadMoreHardware.page++;
						if (parseInt(LoadMoreHardware.page) === parseInt(response.max)) {
							$('.js-load-more').addClass('hidden');
							LoadMoreHardware.page = 1;
							$('.js-hardware-load-btn').addClass('js-load-more');
						}

						Drops.init();
						LazyLoad.init();

					},

				});
			} else {
				$.ajax({
					type: 'POST',
					// eslint-disable-next-line no-undef
					url: mongotelAjax.ajaxUrl,
					data: {
						action: 'LoadMoreHardwareDefault',
						page2: LoadMoreHardware.page2 + 1,
					},
					success: function(response) {
						$(response.htmlPosts).appendTo($('.js-hardware-wrap-lode-more'));
						$(response.htmlPosts2).appendTo($('.js-hardware-wrap-more-lode-more-2'));

						LoadMoreHardware.page2++;
						if (parseInt(LoadMoreHardware.page2) === parseInt(response.max)) {
							$('.js-load-more').addClass('hidden');
							LoadMoreHardware.page2 = 1;
							LoadMoreHardware.page = 1;
						}

						Drops.init();
						LazyLoad.init();
					},

				});
			}

		});

	},
};

export default LoadMoreHardware;
